import { render, staticRenderFns } from "./pf.vue?vue&type=template&id=652957ab&scoped=true"
import script from "./pf.vue?vue&type=script&lang=js"
export * from "./pf.vue?vue&type=script&lang=js"
import style0 from "./pf.vue?vue&type=style&index=0&id=652957ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652957ab",
  null
  
)

export default component.exports